var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletPackagingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D9F4F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#ECFAFC",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 19.6667V16.7505C26.3333 16.0574 26.3333 15.7109 26.1873 15.4979C26.0598 15.3118 25.8622 15.1854 25.6398 15.1476C25.3852 15.1042 25.0706 15.2495 24.4413 15.5399L17.0492 18.9517C16.4879 19.2107 16.2073 19.3402 16.0018 19.5411C15.82 19.7187 15.6813 19.9355 15.5963 20.1749C15.5 20.4457 15.5 20.7547 15.5 21.3729V25.5M26.75 25.0833H26.7583M15.5 22.3333L15.5 27.8333C15.5 28.7667 15.5 29.2335 15.6817 29.59C15.8414 29.9036 16.0964 30.1585 16.41 30.3183C16.7665 30.5 17.2332 30.5 18.1667 30.5H27.8333C28.7668 30.5 29.2335 30.5 29.59 30.3183C29.9036 30.1585 30.1586 29.9036 30.3183 29.59C30.5 29.2335 30.5 28.7667 30.5 27.8333V22.3333C30.5 21.3999 30.5 20.9332 30.3183 20.5767C30.1586 20.2631 29.9036 20.0081 29.59 19.8483C29.2335 19.6667 28.7668 19.6667 27.8333 19.6667L18.1667 19.6667C17.2332 19.6667 16.7665 19.6667 16.41 19.8483C16.0964 20.0081 15.8414 20.2631 15.6817 20.5767C15.5 20.9332 15.5 21.3999 15.5 22.3333ZM27.1667 25.0833C27.1667 25.3134 26.9801 25.5 26.75 25.5C26.5199 25.5 26.3333 25.3134 26.3333 25.0833C26.3333 24.8532 26.5199 24.6667 26.75 24.6667C26.9801 24.6667 27.1667 24.8532 27.1667 25.0833Z",
    stroke: "#0098A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletPackagingIcon);
export default __webpack_public_path__ + "e869867cf8e5f26f30a5b33277b3b4fa.svg";
export { ForwardRef as ReactComponent };